import React from 'react';
import { Image } from 'semantic-ui-react';

// TODO remove // import defaultLogo from '../img/Logo.svg';
import Auth from '../managers/AuthManager';

import { SatCoreRegister } from '../SatCoreRegistry';

import { VIEW_SELECTION } from '../managers/NavigationManager';

import TopNavService from '../services/TopNavService';

const Logo = ({ ariaLabel, history, logoImg, logoUrl, navButton }) => {
  return (
    <>
      {navButton ? (
        <Image
          alt=''
          as={(props) => (
            <button type='button' {...props} aria-label={ariaLabel || 'Return to dashboard button'} role='tab' />
          )}
          className='logo'
          onClick={() => {
            if (logoUrl) {
              window.open(logoUrl, '_blank', 'noopener,noreferrer');
            } else {
              const { topNavObj } = TopNavService.getMainTopNavInfo() || {};

              const routerUrl = topNavObj?.urlPathname ? (
                `${topNavObj.urlPathname}?view=${VIEW_SELECTION[topNavObj.viewSelectionKey]}`
              ) : '/';
              history.push(routerUrl);
            }
          }}
          src={logoImg || Auth.logo} />
      ) : (
        <Image alt='' as='div' className='logo' src={logoImg || Auth.logo} />
      )}
    </>
  );
};

export default Logo;

SatCoreRegister('Logo', Logo);
